import { render } from "./wcEditPage.vue?vue&type=template&id=61117399"
import script from "./wcEditPage.vue?vue&type=script&lang=js"
export * from "./wcEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__